"use client"

import { useEffect, useRef } from 'react'
import { ensureFingerprint } from '@/utils/fingerprint/client'

/**
 * Client component that initializes browser fingerprinting
 * This runs on the client side only and sets the fingerprint cookie
 */
export function FingerprintScript() {
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (hasInitialized.current) return;

        hasInitialized.current = true;

        // Use setTimeout to move fingerprint initialization outside React's current execution
        setTimeout(() => {
            ensureFingerprint().catch(err => {
                console.error('[Fingerprint] Error:', err)
            });
        }, 1000); // Delay by 1000ms (1 second)
    }, []);

    // This component doesn't render anything
    return null;
}